/**
 * EditableContentHeader - Provides Edit/Save/Cancel buttons for editable sections
 * Handles the button UI and state management for edit mode
 */
export default function EditableContentHeader({
  title,
  subtitle,
  isEditMode,
  onEdit,
  onSave,
  onCancel,
  isSaving = false
}) {

  return (
    <div className="mb-8 max-lg:mb-4 flex items-start justify-between">
      <div>
        <h2 className="text-2xl max-lg:text-xl font-bold text-white mb-2 max-lg:mb-1">{title}</h2>
        {subtitle && <p className="text-sm max-lg:text-xs text-gray-400">{subtitle}</p>}
      </div>

      {/* Edit/Save/Cancel Buttons */}
      {isEditMode ? (
        <div className="flex gap-2 max-lg:gap-1.5">
          <button
            onClick={onCancel}
            disabled={isSaving}
            className="bg-gray-700 hover:bg-gray-600 disabled:bg-gray-800 text-white px-6 py-2.5 max-lg:px-4 max-lg:py-2 max-lg:text-sm rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 max-lg:gap-1.5"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
            Cancel
          </button>
          <button
            onClick={onSave}
            disabled={isSaving}
            className="bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 disabled:bg-gray-700 disabled:hover:bg-gray-700 px-6 py-2.5 max-lg:px-4 max-lg:py-2 max-lg:text-sm rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 max-lg:gap-1.5 shadow-lg disabled:shadow-none"
            style={{ color: 'var(--color-text-on-accent)' }}
          >
            {isSaving ? (
              <>
                <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Save
              </>
            )}
          </button>
        </div>
      ) : (
        <button
          onClick={onEdit}
          className="bg-gray-700 hover:bg-gray-600 text-white px-6 py-2.5 max-lg:px-4 max-lg:py-2 max-lg:text-sm rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 max-lg:gap-1.5"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Edit
        </button>
      )}
    </div>
  );
}
